import { RouteType } from "types/RouteType";

const systemHealthRoute: RouteType = {
  name: "SystemHealth",
  path: "/admin/system-health",
  layout: "/admin",
  viewportCard: {
    header: {
      enableBackButton: true,
      title: "System Health",
      enableRefreshButton: true,
      color: "primary",
      component: () => import("./SystemHealth.Header"),
    },
    body: {
      component: () => import("./SystemHealth.Body"),
      grayBackground: false,
    },
  },
  group: "Admin",
  searchAliases: ["status", "health"],
  requiresAuth: true,
  requiresAdmin: true,
  requiresPermission: false,
  enableAutoFind: false,
};

export default systemHealthRoute;
